import { AccountUserType } from './AccountUserType';

export interface IAccount {
  id: string;
  displayName: string;
  category: string;
  description?: string;
  created: string;
  deleteAt?: string;
  usersCount: number;
  licensePackage: string;
  sbmRef?: string;
  state?: AccountState;
  accountUserType?: AccountUserType;
  expirationDate?: string;
}

export enum AccountState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Locked = 'LOCKED',
  SuspendPending = 'SUSPEND_PENDING',
  Suspended = 'SUSPENDED',
  SuspendFailed = 'SUSPEND_FAILED',
  TerminatePending = 'TERMINATE_PENDING',
  Terminated = 'TERMINATED',
  TerminateFailed = 'TERMINATE_FAILED',
  DeleteScheduled = 'DELETE_SCHEDULED',
  DeletePending = 'DELETE_PENDING',
  Deleted = 'DELETED',
  DeleteFailed = 'DELETE_FAILED',
  ResumePending = 'RESUME_PENDING',
  ResumeFailed = 'RESUME_FAILED',
}

export enum AccountStateAction {
  Active = 'Active',
  Reactivate = 'Reactivate',
  Delete = 'Delete',
  DeleteCancel = 'Delete Cancel',
  Lock = 'Lock',
  Suspend = 'Suspend',
  SuspendFailed = 'SuspendFailed',
  Terminate = 'Terminate',
}

export type HttpAccountFilters<F = {}> = F;
